import React from "react";
import MainContainer from "../../components/container/MainContainer";

const Report = () => {
  return (
    <MainContainer className="text-text-1">
      <h4>Reports</h4>
      <div>Reports</div>
    </MainContainer>
  );
};

export default Report;
